import {Emitter} from '../utils/emitter';

export class AssetLoader extends Emitter {
  private items: any;

  constructor(items = []) {
    super();
    this.items = items;
  }

  public load() {
    const loaders = this.items.map(({url, loader}) => this[loader](url));
    return Promise.all(loaders);
  }

  private skip() {
    // @ts-ignore
    return window.PRERENDER || location.origin.includes('localhost');
  }

  private image = url => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(url);
      image.onerror = () => reject(url);
      image.src = url;
    });
  };
}
